import { useState, useEffect, useRef } from "react";
import logo from "./images/techvanto-logo.png";

const LOGO_SRC = logo;

// ── Nav & Footer Data (from original App.js) ─────────────────────────────────

// ── Universal Nav Data ─────────────────────────────────────────────────────────
const NAV_LINKS = [
  {
    label: "Services",
    dropdown: [
      { name: "Web Development", link: "/web-development" },
      { name: "Mobile App Development", link: "/mobile-app-development" },
      { name: "AI & ML Solutions", link: "/ai-ml-solutions" },
      { name: "Cloud DevOps", link: "/cloud" },
      { name: "UI/UX Design", link: "/ui-ux" },
      { name: "E-Commerce Solutions", link: "/ecommerce" },
    ],
  },
  {
    label: "Solutions",
    dropdown: [
      { name: "CRM Solution", link: "/crm-solutions" },
      { name: "ERP Solution", link: "/erp-solutions" },
      { name: "HRM Solution", link: "/hrm-solutions" },
      { name: "LMS Solution", link: "/lms-solutions" },
      { name: "POS Solution", link: "/pos-solutions" },
      { name: "SaaS Platform", link: "/saas-platform" },
    ],
  },
  {
    label: "Industries",
      dropdown: [
      { name: "Healthcare", link: "/healthcare-solution" },
      { name: "FinTech", link: "/fintech-solution" },
      { name: "EdTech", link: "/edtech-solution" },
      { name: "Retail & E-Commerce", link: "retail-ecommerce-solution" },
      { name: "Real Estate", link: "/realestate-solution" },
      { name: "Logistics", link: "/logistic-solution" },
    ],
  },
  { label: "Portfolio", dropdown: null, link: "/portfolio" },
  { label: "About", dropdown: null, link: "/#about" },
  { label: "Blog", dropdown: null, link: "/blogs" },
];
// ── Portfolio Data ────────────────────────────────────────────────────────────

const CATEGORIES = ["All", "Web App", "Mobile App", "AI & ML", "E-Commerce", "SaaS"];

const PROJECTS = [
  {
    id: 1,
    title: "HealthTrack Pro",
    category: "Web App",
    industry: "Healthcare",
    desc: "A comprehensive healthcare management platform with real-time patient monitoring, AI-driven diagnostics, and seamless EHR integration for 200+ hospitals.",
    tags: ["React", "Node.js", "AI", "AWS"],
    img: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&h=400&fit=crop&auto=format",
    color: "#3B82F6",
    accent: "#EFF6FF",
    results: ["40% faster diagnosis", "200+ hospitals", "99.9% uptime"],
    link: "#",
    featured: true,
  },
  {
    id: 2,
    title: "FinEdge Mobile",
    category: "Mobile App",
    industry: "FinTech",
    desc: "A next-gen financial super-app enabling seamless payments, investments, and budgeting for 50,000+ daily active users across iOS & Android.",
    tags: ["Flutter", "Firebase", "Python", "ML"],
    img: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=600&h=400&fit=crop&auto=format",
    color: "#8B5CF6",
    accent: "#F5F3FF",
    results: ["50k+ DAUs", "4.8★ App Store", "₹2Cr+ daily txns"],
    link: "#",
    featured: true,
  },
  {
    id: 3,
    title: "LearningHub LMS",
    category: "SaaS",
    industry: "EdTech",
    desc: "A scalable Learning Management System that grew an EdTech startup from 200 to 20,000 students with live classes, AI tutoring, and gamified progress tracking.",
    tags: ["Next.js", "PostgreSQL", "WebRTC", "Redis"],
    img: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=600&h=400&fit=crop&auto=format",
    color: "#10B981",
    accent: "#F0FDF4",
    results: ["20k students", "100x growth", "Live classes"],
    link: "#",
    featured: true,
  },
  {
    id: 4,
    title: "Pashmkaar Store",
    category: "E-Commerce",
    industry: "Retail",
    desc: "A premium e-commerce platform for handcrafted Kashmiri goods, featuring AR try-on, personalised recommendations, and multi-currency checkout.",
    tags: ["Shopify", "React", "Node.js", "AI"],
    img: "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=600&h=400&fit=crop&auto=format",
    color: "#F59E0B",
    accent: "#FFFBEB",
    results: ["3x conversions", "AR try-on", "12 currencies"],
    link: "#",
    featured: false,
  },
  {
    id: 5,
    title: "LogiTrack AI",
    category: "AI & ML",
    industry: "Logistics",
    desc: "An intelligent logistics optimisation engine with predictive routing, demand forecasting, and real-time fleet management powering a pan-India supply chain.",
    tags: ["Python", "TensorFlow", "AWS", "React"],
    img: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=600&h=400&fit=crop&auto=format",
    color: "#EF4444",
    accent: "#FEF2F2",
    results: ["28% fuel saving", "Real-time tracking", "AI routing"],
    link: "#",
    featured: false,
  },
  {
    id: 6,
    title: "GetMyProperty",
    category: "Web App",
    industry: "Real Estate",
    desc: "A full-stack real estate marketplace with 3D virtual tours, AI-powered property valuation, and instant mortgage calculators for 10+ cities.",
    tags: ["React", "Laravel", "MySQL", "Three.js"],
    img: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&h=400&fit=crop&auto=format",
    color: "#EC4899",
    accent: "#FDF2F8",
    results: ["10 cities", "3D tours", "10k+ listings"],
    link: "#",
    featured: false,
  },
  {
    id: 7,
    title: "TravelAmour App",
    category: "Mobile App",
    industry: "Travel",
    desc: "A personalised travel companion app with AI itinerary generation, community reviews, and instant booking for flights, hotels, and experiences.",
    tags: ["React Native", "GraphQL", "MongoDB", "GCP"],
    img: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=600&h=400&fit=crop&auto=format",
    color: "#06B6D4",
    accent: "#ECFEFF",
    results: ["AI itineraries", "4.9★ rating", "500k+ trips"],
    link: "#",
    featured: false,
  },
  {
    id: 8,
    title: "iClinix Portal",
    category: "SaaS",
    industry: "Healthcare",
    desc: "A white-label telemedicine SaaS for clinics, featuring video consultations, e-prescriptions, appointment scheduling, and integrated lab reports.",
    tags: ["Vue.js", "Node.js", "WebRTC", "PostgreSQL"],
    img: "https://images.unsplash.com/photo-1576671081837-49000212a370?w=600&h=400&fit=crop&auto=format",
    color: "#3B82F6",
    accent: "#EFF6FF",
    results: ["300+ clinics", "Video consults", "HIPAA compliant"],
    link: "#",
    featured: false,
  },
  {
    id: 9,
    title: "Aviaknots Platform",
    category: "E-Commerce",
    industry: "Fashion",
    desc: "A luxury fashion marketplace with designer storefronts, AI style matching, and curated collections serving 50k+ shoppers across South Asia.",
    tags: ["Shopify Plus", "React", "Klaviyo", "AI"],
    img: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=600&h=400&fit=crop&auto=format",
    color: "#8B5CF6",
    accent: "#F5F3FF",
    results: ["50k shoppers", "AI styling", "150+ brands"],
    link: "#",
    featured: false,
  },
];

const STATS = [
  { value: "1,560+", label: "Projects Delivered", icon: "🚀" },
  { value: "20+", label: "Countries Served", icon: "🌍" },
  { value: "98%", label: "Client Retention", icon: "❤️" },
  { value: "7+ Yrs", label: "In Industry", icon: "🏆" },
];

const INDUSTRIES = [
  { name: "Healthcare", icon: "🏥", count: 42 },
  { name: "FinTech", icon: "💳", count: 38 },
  { name: "EdTech", icon: "🎓", count: 55 },
  { name: "Retail", icon: "🛍️", count: 71 },
  { name: "Real Estate", icon: "🏠", count: 29 },
  { name: "Logistics", icon: "🚚", count: 34 },
  { name: "Travel", icon: "✈️", count: 27 },
  { name: "SaaS", icon: "☁️", count: 63 },
];


// ── Helper Components ─────────────────────────────────────────────────────────

function Badge({ children, color = "#3B82F6" }) {
  return (
    <span style={{
      display: "inline-block", padding: "3px 10px",
      borderRadius: 99, fontSize: 11, fontWeight: 600,
      background: color + "18", color, border: `1px solid ${color}33`,
      letterSpacing: ".04em", textTransform: "uppercase",
    }}>{children}</span>
  );
}

// ── Universal Navbar ─────────────────────────────────────────────────────────
function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  // Smart logic to check which page we are currently on
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000,
      background: scrolled ? "rgba(255,255,255,0.97)" : "rgba(255,255,255,0.9)",
      backdropFilter: "blur(16px)",
      borderBottom: scrolled ? "1px solid #E5E7EB" : "1px solid transparent",
      boxShadow: scrolled ? "0 2px 24px rgba(0,0,0,0.08)" : "none",
      transition: "all .3s ease",
    }}>
      <div style={{
        background: "linear-gradient(90deg,#1E3A8A,#3B82F6)",
        color: "#fff", fontSize: 12, padding: "6px 40px",
        display: "flex", justifyContent: "space-between", alignItems: "center",
        flexWrap: "wrap", gap: 8,
      }}>
        <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
          <span>📞 +91 96462 06032</span>
          <span>✉️ info@techvanto.com</span>
        </div>
        <span className="topbar-right" style={{ opacity: .85 }}>🌏 Trusted by 1500+ clients across 20+ countries</span>
      </div>
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "0 40px", height: 68, maxWidth: 1280, margin: "0 auto",
      }}>
        <a href="/" style={{ display: "flex", alignItems: "center", flexShrink: 0, textDecoration: "none" }}>
          <img src={LOGO_SRC} alt="Techvanto" style={{ height: 150, width: "auto", objectFit: "contain", display: "block" }} />
        </a>
        <div className="nav-links" style={{ alignItems: "center", gap: 4 }}>
          {NAV_LINKS.map(link => {
            // Check if this specific main link is the active page
            const isActive = link.link && currentPath.includes(link.label.toLowerCase());

            return (
              <div key={link.label} style={{ position: "relative" }}
                onMouseEnter={() => link.dropdown && setActiveDropdown(link.label)}
                onMouseLeave={() => setActiveDropdown(null)}
              >
                {link.link ? (
                  <a href={link.link} style={{
                    background: isActive ? "#EFF6FF" : "none",
                    border: isActive ? "1px solid #BFDBFE" : "1px solid transparent",
                    cursor: "pointer", padding: "8px 14px", fontSize: 14, fontWeight: 600,
                    color: isActive ? "#3B82F6" : "#374151",
                    display: "flex", alignItems: "center", gap: 4, transition: "color .2s, background .2s",
                    fontFamily: "'Sora',sans-serif", borderRadius: 8, textDecoration: "none"
                  }}>
                    {link.label}
                  </a>
                ) : (
                  <button style={{
                    // Highlight the "Services" button if we are on the web-development page
                    background: (link.label === "Services" && currentPath === "/web-development") ? "#EFF6FF" : "none",
                    border: (link.label === "Services" && currentPath === "/web-development") ? "1px solid #BFDBFE" : "1px solid transparent",
                    cursor: "pointer", padding: "8px 14px", fontSize: 14, fontWeight: 600,
                    color: (link.label === "Services" && currentPath === "/web-development") ? "#3B82F6" : activeDropdown === link.label ? "#3B82F6" : "#374151",
                    display: "flex", alignItems: "center", gap: 4, transition: "color .2s",
                    fontFamily: "'Sora',sans-serif", borderRadius: 8,
                  }}>
                    {link.label}
                    {link.dropdown && <span style={{ fontSize: 10, transition: "transform .2s", transform: activeDropdown === link.label ? "rotate(180deg)" : "rotate(0)" }}>▾</span>}
                  </button>
                )}
                {link.dropdown && activeDropdown === link.label && (
                  <div style={{
                    position: "absolute", top: "100%", left: 0, zIndex: 200,
                    background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12,
                    boxShadow: "0 16px 48px rgba(0,0,0,0.12)", minWidth: 220,
                    padding: "8px 0", animation: "fadeIn .2s ease",
                  }}>
                    {link.dropdown.map(item => (
                      <a key={item.name} href={item.link} style={{
                        display: "block", padding: "9px 20px", fontSize: 13.5,
                        // Highlight the active item inside the dropdown
                        color: currentPath === item.link ? "#3B82F6" : "#374151",
                        background: currentPath === item.link ? "#EFF6FF" : "none",
                        fontWeight: currentPath === item.link ? 700 : 500,
                        textDecoration: "none", transition: "all .15s",
                      }}
                        onMouseEnter={e => { e.target.style.background = "#EFF6FF"; e.target.style.color = "#3B82F6"; }}
                        onMouseLeave={e => { 
                          e.target.style.background = currentPath === item.link ? "#EFF6FF" : "none"; 
                          e.target.style.color = currentPath === item.link ? "#3B82F6" : "#374151"; 
                        }}
                      >{item.name}</a>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <a href="/#contact" className="nav-cta" style={{
            background: "linear-gradient(135deg,#1E3A8A,#3B82F6)", color: "#fff",
            padding: "10px 22px", borderRadius: 8, fontSize: 13.5, fontWeight: 700,
            textDecoration: "none", boxShadow: "0 4px 14px rgba(59,130,246,.35)",
            transition: "transform .2s, box-shadow .2s", fontFamily: "'Sora',sans-serif",
          }}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = "0 8px 20px rgba(59,130,246,.45)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 4px 14px rgba(59,130,246,.35)"; }}
          >Get Free Consultation</a>
          <button onClick={() => setMobileOpen(!mobileOpen)} className="mob-menu-btn" style={{
            background: "none", border: "1px solid #E5E7EB", borderRadius: 8,
            padding: "8px 12px", cursor: "pointer", fontSize: 18, color: "#374151",
          }}>☰</button>
        </div>
      </div>
      {mobileOpen && (
        <div style={{ background: "#fff", borderTop: "1px solid #E5E7EB", padding: "16px 24px 24px", display: "flex", flexDirection: "column", gap: 4 }}>
          <div style={{ paddingBottom: 14, borderBottom: "1px solid #F3F4F6", marginBottom: 4 }}>
            <img src={LOGO_SRC} alt="Techvanto" style={{ height: 40, width: "auto", objectFit: "contain" }} />
          </div>
          {NAV_LINKS.map(l => (
            <a key={l.label} href={l.link || "/#services"} style={{ padding: "10px 0", color: currentPath.includes(l.label.toLowerCase()) ? "#3B82F6" : "#374151", fontWeight: 600, textDecoration: "none", borderBottom: "1px solid #F3F4F6", fontFamily: "'Sora',sans-serif" }}>{l.label}</a>
          ))}
          <a href="/#contact" style={{ marginTop: 12, background: "linear-gradient(135deg,#1E3A8A,#3B82F6)", color: "#fff", padding: "13px", borderRadius: 8, textAlign: "center", fontWeight: 700, textDecoration: "none" }}>Get Free Consultation</a>
        </div>
      )}
    </nav>
  );
}
// ── Portfolio Hero ────────────────────────────────────────────────────────────

function PortfolioHero() {
  return (
    <section style={{
      paddingTop: 140, paddingBottom: 80,
      background: "linear-gradient(160deg,#EFF6FF 0%,#F0FDF4 40%,#FFF7ED 100%)",
      position: "relative", overflow: "hidden",
      textAlign: "center",
    }}>
      <div style={{ position: "absolute", top: -80, right: -80, width: 500, height: 500, borderRadius: "50%", background: "radial-gradient(circle,rgba(59,130,246,.12),transparent 70%)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", bottom: -60, left: -100, width: 500, height: 500, borderRadius: "50%", background: "radial-gradient(circle,rgba(16,185,129,.09),transparent 70%)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none", backgroundImage: "linear-gradient(rgba(59,130,246,.04) 1px,transparent 1px),linear-gradient(90deg,rgba(59,130,246,.04) 1px,transparent 1px)", backgroundSize: "60px 60px" }} />

      <div style={{ maxWidth: 800, margin: "0 auto", padding: "0 24px", position: "relative" }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "#EFF6FF", border: "1px solid #BFDBFE", borderRadius: 99, padding: "6px 16px", marginBottom: 24 }}>
          <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#3B82F6", display: "inline-block", animation: "pulse 2s infinite" }} />
          <span style={{ fontSize: 13, fontWeight: 600, color: "#1E40AF" }}>🏆 1,560+ Projects Delivered Worldwide</span>
        </div>

        <h1 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(36px,5vw,64px)", fontWeight: 900, color: "#0F172A", lineHeight: 1.1, marginBottom: 20 }}>
          Our Work Speaks
          <br />
          <span style={{ background: "linear-gradient(135deg,#1E3A8A,#3B82F6,#06B6D4)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>
            For Itself
          </span>
        </h1>

        <p style={{ fontSize: 17, color: "#6B7280", lineHeight: 1.75, maxWidth: 580, margin: "0 auto 40px" }}>
          From healthcare giants to FinTech disruptors — explore the transformative digital products we've crafted for 1,560+ clients across 20+ countries.
        </p>

        <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
          <a href="#projects" style={{
            background: "linear-gradient(135deg,#1E3A8A,#3B82F6)", color: "#fff",
            padding: "14px 28px", borderRadius: 10, fontWeight: 700, fontSize: 15,
            textDecoration: "none", boxShadow: "0 6px 20px rgba(59,130,246,.4)",
            transition: "transform .2s,box-shadow .2s", fontFamily: "'Sora',sans-serif",
          }}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 10px 28px rgba(59,130,246,.5)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 6px 20px rgba(59,130,246,.4)"; }}
          >View All Projects →</a>
          <a href="#contact" style={{
            background: "#fff", color: "#1E3A8A",
            padding: "14px 28px", borderRadius: 10, fontWeight: 700, fontSize: 15,
            textDecoration: "none", border: "2px solid #BFDBFE",
            transition: "all .2s", fontFamily: "'Sora',sans-serif",
          }}
            onMouseEnter={e => { e.currentTarget.style.background = "#EFF6FF"; e.currentTarget.style.borderColor = "#93C5FD"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.borderColor = "#BFDBFE"; }}
          >💬 Start Your Project</a>
        </div>
      </div>
    </section>
  );
}

// ── Stats Bar ─────────────────────────────────────────────────────────────────

function StatsBar() {
  return (
    <section style={{ background: "#0F172A", padding: "48px 40px" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 32, textAlign: "center" }} className="stats-grid">
        {STATS.map(s => (
          <div key={s.label}>
            <div style={{ fontSize: 28, marginBottom: 6 }}>{s.icon}</div>
            <div style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(28px,3vw,40px)", fontWeight: 900, color: "#fff", lineHeight: 1 }}>{s.value}</div>
            <div style={{ color: "#64748B", fontSize: 13, marginTop: 6, fontWeight: 500 }}>{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

// ── Featured Projects ─────────────────────────────────────────────────────────

function FeaturedProjects() {
  const featured = PROJECTS.filter(p => p.featured);
  const [hov, setHov] = useState(null);

  return (
    <section style={{ padding: "96px 40px", background: "#fff" }} className="section-pad">
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 64 }}>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#3B82F6", letterSpacing: ".1em", textTransform: "uppercase" }}>Featured Work</span>
          <h2 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(28px,4vw,44px)", fontWeight: 900, color: "#0F172A", marginTop: 8, marginBottom: 16 }}>Headline Projects</h2>
          <p style={{ color: "#6B7280", fontSize: 16, maxWidth: 520, margin: "0 auto" }}>Our most impactful work — where bold ambition met flawless execution.</p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 60 }}>
          {featured.map((project, idx) => (
            <div key={project.id} style={{
              display: "grid",
              gridTemplateColumns: idx % 2 === 0 ? "1fr 1fr" : "1fr 1fr",
              gap: 56,
              alignItems: "center",
              direction: idx % 2 === 0 ? "ltr" : "rtl",
            }} className="featured-project-grid">
              {/* Image */}
              <div style={{ direction: "ltr", position: "relative", borderRadius: 20, overflow: "hidden", boxShadow: `0 32px 80px ${project.color}30` }}
                onMouseEnter={() => setHov(project.id)}
                onMouseLeave={() => setHov(null)}
              >
                <img src={project.img} alt={project.title} style={{ width: "100%", height: 380, objectFit: "cover", display: "block", transition: "transform .5s ease", transform: hov === project.id ? "scale(1.04)" : "scale(1)" }} />
                <div style={{ position: "absolute", inset: 0, background: `linear-gradient(to top, ${project.color}cc 0%, transparent 60%)`, opacity: hov === project.id ? 1 : 0, transition: "opacity .3s" }} />
                <div style={{ position: "absolute", top: 20, left: 20, background: project.color, color: "#fff", fontSize: 12, fontWeight: 700, padding: "5px 14px", borderRadius: 99, letterSpacing: ".04em" }}>
                  {project.category}
                </div>
              </div>

              {/* Content */}
              <div style={{ direction: "ltr" }}>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
                  {project.tags.map(t => (
                    <span key={t} style={{ background: project.accent, color: project.color, fontSize: 11, fontWeight: 700, padding: "4px 12px", borderRadius: 99, border: `1px solid ${project.color}30` }}>{t}</span>
                  ))}
                </div>
                <h3 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(24px,3vw,36px)", fontWeight: 900, color: "#0F172A", marginBottom: 16, lineHeight: 1.2 }}>{project.title}</h3>
                <p style={{ color: "#6B7280", fontSize: 16, lineHeight: 1.75, marginBottom: 28 }}>{project.desc}</p>

                {/* Results */}
                <div style={{ display: "flex", gap: 16, marginBottom: 32, flexWrap: "wrap" }}>
                  {project.results.map(r => (
                    <div key={r} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ width: 7, height: 7, borderRadius: "50%", background: project.color, display: "inline-block", flexShrink: 0 }} />
                      <span style={{ fontSize: 13.5, fontWeight: 700, color: "#0F172A" }}>{r}</span>
                    </div>
                  ))}
                </div>

                <a href={project.link} style={{
                  display: "inline-flex", alignItems: "center", gap: 8,
                  background: project.color, color: "#fff",
                  padding: "13px 26px", borderRadius: 10, fontWeight: 700, fontSize: 14,
                  textDecoration: "none", fontFamily: "'Sora',sans-serif",
                  boxShadow: `0 6px 20px ${project.color}40`,
                  transition: "transform .2s, box-shadow .2s",
                }}
                  onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = `0 10px 28px ${project.color}55`; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = `0 6px 20px ${project.color}40`; }}
                >View Case Study →</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── All Projects Grid ─────────────────────────────────────────────────────────

function ProjectsGrid() {
  const [active, setActive] = useState("All");
  const [hov, setHov] = useState(null);

  const filtered = active === "All" ? PROJECTS : PROJECTS.filter(p => p.category === active);

  return (
    <section id="projects" style={{ padding: "96px 40px", background: "#F8FAFC" }} className="section-pad">
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 52 }}>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#3B82F6", letterSpacing: ".1em", textTransform: "uppercase" }}>All Projects</span>
          <h2 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(28px,4vw,44px)", fontWeight: 900, color: "#0F172A", marginTop: 8, marginBottom: 16 }}>Browse Our Portfolio</h2>
          <p style={{ color: "#6B7280", fontSize: 16, maxWidth: 520, margin: "0 auto" }}>Filter by category and explore 1,560+ successful digital products.</p>
        </div>

        {/* Filter Tabs */}
        <div style={{ display: "flex", justifyContent: "center", gap: 10, flexWrap: "wrap", marginBottom: 48 }}>
          {CATEGORIES.map(cat => (
            <button key={cat} onClick={() => setActive(cat)} style={{
              padding: "9px 22px", borderRadius: 99, fontSize: 13.5, fontWeight: 700,
              cursor: "pointer", transition: "all .2s", fontFamily: "'Sora',sans-serif",
              background: active === cat ? "linear-gradient(135deg,#1E3A8A,#3B82F6)" : "#fff",
              color: active === cat ? "#fff" : "#374151",
              border: active === cat ? "none" : "1.5px solid #E5E7EB",
              boxShadow: active === cat ? "0 4px 14px rgba(59,130,246,.35)" : "none",
            }}>
              {cat}
            </button>
          ))}
        </div>

        {/* Project Cards */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(340px,1fr))", gap: 28 }}>
          {filtered.map(project => (
            <div key={project.id}
              onMouseEnter={() => setHov(project.id)}
              onMouseLeave={() => setHov(null)}
              style={{
                background: "#fff", borderRadius: 20, overflow: "hidden",
                border: `1px solid ${hov === project.id ? project.color + "55" : "#E5E7EB"}`,
                boxShadow: hov === project.id ? `0 20px 60px ${project.color}20` : "0 2px 12px rgba(0,0,0,.04)",
                transition: "all .3s ease", transform: hov === project.id ? "translateY(-6px)" : "none",
              }}>
              <div style={{ position: "relative", overflow: "hidden" }}>
                <img src={project.img} alt={project.title} style={{ width: "100%", height: 220, objectFit: "cover", display: "block", transition: "transform .4s", transform: hov === project.id ? "scale(1.06)" : "scale(1)" }} />
                <div style={{ position: "absolute", top: 14, left: 14, background: project.color, color: "#fff", fontSize: 11, fontWeight: 700, padding: "4px 12px", borderRadius: 99 }}>{project.category}</div>
                <div style={{ position: "absolute", top: 14, right: 14, background: "rgba(255,255,255,.92)", color: "#374151", fontSize: 11, fontWeight: 600, padding: "4px 12px", borderRadius: 99 }}>{project.industry}</div>
              </div>

              <div style={{ padding: "24px 24px 28px" }}>
                <h3 style={{ fontFamily: "'Sora',sans-serif", fontSize: 20, fontWeight: 800, color: "#0F172A", marginBottom: 10 }}>{project.title}</h3>
                <p style={{ color: "#6B7280", fontSize: 14, lineHeight: 1.7, marginBottom: 18 }}>{project.desc}</p>

                {/* Tags */}
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 18 }}>
                  {project.tags.map(t => (
                    <span key={t} style={{ background: project.accent, color: project.color, fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 99 }}>{t}</span>
                  ))}
                </div>

                {/* Results */}
                <div style={{ borderTop: "1px solid #F1F5F9", paddingTop: 16, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                    {project.results.slice(0, 2).map(r => (
                      <span key={r} style={{ fontSize: 11, color: "#64748B", fontWeight: 600, display: "flex", alignItems: "center", gap: 4 }}>
                        <span style={{ color: project.color }}>✓</span>{r}
                      </span>
                    ))}
                  </div>
                  <a href={project.link} style={{
                    color: project.color, fontSize: 13, fontWeight: 700,
                    textDecoration: "none", display: "flex", alignItems: "center", gap: 4,
                    transition: "gap .2s",
                  }}
                    onMouseEnter={e => e.currentTarget.style.gap = "8px"}
                    onMouseLeave={e => e.currentTarget.style.gap = "4px"}
                  >View →</a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Load more */}
        <div style={{ textAlign: "center", marginTop: 56 }}>
          <button style={{
            background: "#fff", color: "#374151", border: "2px solid #E5E7EB",
            padding: "14px 36px", borderRadius: 10, fontWeight: 700, fontSize: 15,
            cursor: "pointer", fontFamily: "'Sora',sans-serif", transition: "all .2s",
          }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = "#93C5FD"; e.currentTarget.style.color = "#1E3A8A"; e.currentTarget.style.background = "#EFF6FF"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = "#E5E7EB"; e.currentTarget.style.color = "#374151"; e.currentTarget.style.background = "#fff"; }}
          >Load More Projects ↓</button>
        </div>
      </div>
    </section>
  );
}

// ── Industries Section ────────────────────────────────────────────────────────

function Industries() {
  const [hov, setHov] = useState(null);

  return (
    <section style={{ padding: "96px 40px", background: "#fff" }} className="section-pad">
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 56 }}>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#3B82F6", letterSpacing: ".1em", textTransform: "uppercase" }}>Domains</span>
          <h2 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(28px,4vw,44px)", fontWeight: 900, color: "#0F172A", marginTop: 8, marginBottom: 16 }}>Industries We Serve</h2>
          <p style={{ color: "#6B7280", fontSize: 16, maxWidth: 520, margin: "0 auto" }}>Deep domain expertise across every major vertical — we speak your industry's language.</p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))", gap: 20 }}>
          {INDUSTRIES.map((ind, i) => {
            const colors = ["#3B82F6", "#8B5CF6", "#10B981", "#F59E0B", "#EF4444", "#EC4899", "#06B6D4", "#6366F1"];
            const c = colors[i % colors.length];
            return (
              <div key={ind.name}
                onMouseEnter={() => setHov(ind.name)}
                onMouseLeave={() => setHov(null)}
                style={{
                  padding: "28px 24px", borderRadius: 16,
                  border: `1.5px solid ${hov === ind.name ? c + "55" : "#E5E7EB"}`,
                  background: hov === ind.name ? c + "08" : "#fff",
                  boxShadow: hov === ind.name ? `0 12px 40px ${c}18` : "none",
                  transition: "all .25s ease", cursor: "default",
                  transform: hov === ind.name ? "translateY(-4px)" : "none",
                }}>
                <div style={{ fontSize: 32, marginBottom: 12 }}>{ind.icon}</div>
                <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, fontSize: 16, color: "#0F172A", marginBottom: 4 }}>{ind.name}</div>
                <div style={{ fontSize: 13, color: c, fontWeight: 700 }}>{ind.count}+ Projects</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

// ── Process / Approach ────────────────────────────────────────────────────────

function Approach() {
  const steps = [
    { n: "01", title: "Discovery Call", desc: "We learn your goals, users, and constraints in a focused strategy session.", icon: "🔍" },
    { n: "02", title: "Scope & Quote", desc: "Detailed SOW with timeline, milestones, and a transparent fixed or T&M price.", icon: "📋" },
    { n: "03", title: "Design Sprint", desc: "Wireframes to high-fidelity prototypes, validated with stakeholder sign-off.", icon: "🎨" },
    { n: "04", title: "Agile Build", desc: "Bi-weekly sprints, daily standups, and full access to your project dashboard.", icon: "⚙️" },
    { n: "05", title: "QA & Launch", desc: "Rigorous testing, soft launch, then full production go-live with monitoring.", icon: "🚀" },
  ];

  return (
    <section style={{ padding: "96px 40px", background: "linear-gradient(160deg,#EFF6FF 0%,#F0FDF4 100%)" }} className="section-pad">
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 64 }}>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#3B82F6", letterSpacing: ".1em", textTransform: "uppercase" }}>How We Work</span>
          <h2 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(28px,4vw,44px)", fontWeight: 900, color: "#0F172A", marginTop: 8, marginBottom: 16 }}>Our Delivery Process</h2>
          <p style={{ color: "#6B7280", fontSize: 16, maxWidth: 520, margin: "0 auto" }}>A battle-tested framework that's shipped 1,560+ products on time and on budget.</p>
        </div>

        <div className="process-grid" style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 0, position: "relative" }}>
          {/* Connector line */}
          <div className="process-line" style={{ position: "absolute", top: 40, left: "10%", right: "10%", height: 2, background: "linear-gradient(90deg,#3B82F6,#8B5CF6,#10B981,#F59E0B,#EF4444)", zIndex: 0, borderRadius: 2 }} />

          {steps.map((step, i) => {
            const colors = ["#3B82F6", "#8B5CF6", "#10B981", "#F59E0B", "#EF4444"];
            const c = colors[i];
            return (
              <div key={step.n} style={{ textAlign: "center", padding: "0 16px", position: "relative", zIndex: 1 }}>
                <div style={{ width: 80, height: 80, borderRadius: "50%", background: "#fff", border: `3px solid ${c}`, margin: "0 auto 24px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 28, boxShadow: `0 8px 24px ${c}30` }}>
                  {step.icon}
                </div>
                <div style={{ fontSize: 11, fontWeight: 800, color: c, letterSpacing: ".08em", marginBottom: 8 }}>STEP {step.n}</div>
                <h4 style={{ fontFamily: "'Sora',sans-serif", fontSize: 15, fontWeight: 800, color: "#0F172A", marginBottom: 8 }}>{step.title}</h4>
                <p style={{ fontSize: 13, color: "#6B7280", lineHeight: 1.6 }}>{step.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

// ── Contact Form Section (Unified Split Layout) ───────────────────────────────

function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", service: "", query: "" });
  const [focused, setFocused] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const services = [
    "Web Development", "Mobile App Development", "AI & ML Solutions",
    "UI/UX Design", "Cloud & DevOps", "E-Commerce", "Other",
  ];

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => { setLoading(false); setSubmitted(true); }, 1600);
  };

  const inputStyle = (name) => ({
    width: "100%", padding: "14px 16px", borderRadius: 12, fontSize: 14.5,
    border: `2px solid ${focused === name ? "#3B82F6" : "#E5E7EB"}`,
    background: focused === name ? "#F0F6FF" : "#FAFAFA",
    color: "#0F172A", outline: "none", fontFamily: "'Sora',sans-serif",
    transition: "all .2s", boxShadow: focused === name ? "0 0 0 4px rgba(59,130,246,.1)" : "none",
  });

  return (
    <section id="contact" style={{ padding: "96px 40px", background: "linear-gradient(160deg,#F8FAFC 0%,#EFF6FF 100%)", position: "relative", overflow: "hidden" }}>
      {/* Decorative blobs */}
      <div style={{ position: "absolute", top: -80, right: -60, width: 400, height: 400, borderRadius: "50%", background: "radial-gradient(circle,rgba(59,130,246,.08),transparent 70%)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", bottom: -60, left: -40, width: 350, height: 350, borderRadius: "50%", background: "radial-gradient(circle,rgba(16,185,129,.07),transparent 70%)", pointerEvents: "none" }} />

      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 60 }}>
          <Badge color="#3B82F6">Contact Us</Badge>
          <h2 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(28px,4vw,46px)", fontWeight: 800, color: "#0F172A", margin: "16px 0 14px" }}>
            Let's Build Something Amazing
          </h2>
          <p style={{ color: "#6B7280", maxWidth: 520, margin: "0 auto", fontSize: 16, lineHeight: 1.75 }}>
            Got a project in mind? Tell us about it and our team will get back to you within 24 hours.
          </p>
        </div>

        {/* ── Single Merged Grid Container ── */}
        <div className="contact-grid" style={{ maxWidth: 1200, margin: "0 auto" }}>

          {/* ── LEFT COLUMN: Info & Why Us (Merged into Blue Background) ── */}
          <div className="info-panel" style={{
            background: "linear-gradient(135deg,#1E3A8A,#2563EB,#3B82F6)",
            position: "relative", overflow: "hidden", display: "flex", flexDirection: "column",
          }}>
            {/* Background circular decorations */}
            <div style={{ position: "absolute", top: -40, right: -40, width: 250, height: 250, borderRadius: "50%", background: "rgba(255,255,255,.06)" }} />
            <div style={{ position: "absolute", bottom: -30, left: -30, width: 180, height: 180, borderRadius: "50%", background: "rgba(255,255,255,.04)" }} />

            <div style={{ position: "relative", zIndex: 1, flexGrow: 1 }}>
              <h3 style={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, fontSize: 26, color: "#fff", marginBottom: 8 }}>
                Get in Touch
              </h3>
              <p style={{ color: "rgba(255,255,255,.8)", fontSize: 14.5, lineHeight: 1.7, marginBottom: 36 }}>
                We're here to help you transform your ideas into world-class digital products.
              </p>

              {[
                { icon: "📞", label: "Phone", val: "+91 96462 06032" },
                { icon: "✉️", label: "Email", val: "info@techvanto.com" },
                { icon: "📍", label: "Location", val: "New Delhi, India 🇮🇳" },
                { icon: "⏰", label: "Working Hours", val: "Mon–Sat, 9AM – 7PM IST" },
              ].map(item => (
                <div key={item.label} style={{ display: "flex", gap: 14, marginBottom: 20, alignItems: "flex-start" }}>
                  <div style={{ width: 42, height: 42, borderRadius: 10, background: "rgba(255,255,255,.12)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0 }}>
                    {item.icon}
                  </div>
                  <div>
                    <div style={{ fontSize: 11, color: "rgba(255,255,255,.6)", fontWeight: 600, textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 3 }}>{item.label}</div>
                    <div style={{ fontSize: 14.5, color: "#fff", fontWeight: 600 }}>{item.val}</div>
                  </div>
                </div>
              ))}

              {/* Divider Line */}
              <div style={{ height: 1, background: "rgba(255,255,255,.15)", margin: "36px 0" }} />

              {/* Integrated "Why Work With Us?" */}
              <h4 style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: 17, color: "#fff", marginBottom: 20 }}>Why Work With Us?</h4>
              {[
                ["⚡", "Response in under 24 hours"],
                ["🔒", "NDA signing available"],
                ["🎯", "Free project estimation"],
                ["🤝", "Dedicated project manager"],
                ["💳", "Flexible engagement models"],
              ].map(([icon, text]) => (
                <div key={text} style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 14 }}>
                  <span style={{ fontSize: 18 }}>{icon}</span>
                  <span style={{ fontSize: 14, color: "rgba(255,255,255,.85)", fontWeight: 500 }}>{text}</span>
                </div>
              ))}
            </div>

            {/* Social row pinned to bottom via flex */}
            <div style={{ display: "flex", gap: 10, marginTop: 40, position: "relative", zIndex: 1 }}>
              {["𝕏", "in", "𝔾", "▶"].map((icon, i) => (
                <a key={i} href="#" style={{
                  width: 36, height: 36, borderRadius: 9, background: "rgba(255,255,255,.12)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: "rgba(255,255,255,.9)", textDecoration: "none", fontSize: 13, fontWeight: 700,
                  transition: "all .2s",
                }}
                  onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,.25)"; e.currentTarget.style.color = "#fff"; }}
                  onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,.12)"; e.currentTarget.style.color = "rgba(255,255,255,.9)"; }}
                >{icon}</a>
              ))}
            </div>
          </div>

          {/* ── RIGHT COLUMN: Contact Form (White Background) ── */}
          <div className="form-panel" style={{ background: "#fff" }}>
            {submitted ? (
              <div style={{ textAlign: "center", padding: "40px 0" }}>
                <div style={{
                  width: 88, height: 88, borderRadius: "50%",
                  background: "linear-gradient(135deg,#10B981,#059669)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  margin: "0 auto 24px", boxShadow: "0 12px 36px rgba(16,185,129,.35)",
                  fontSize: 40, animation: "fadeIn .4s ease",
                }}>✓</div>
                <h3 style={{ fontFamily: "'Sora',sans-serif", fontSize: 24, fontWeight: 800, color: "#0F172A", marginBottom: 12 }}>
                  Message Sent! 🎉
                </h3>
                <p style={{ color: "#6B7280", fontSize: 15, lineHeight: 1.7, maxWidth: 340, margin: "0 auto 28px" }}>
                  Thank you for reaching out. Our team will contact you within 24 hours.
                </p>
                <button onClick={() => { setSubmitted(false); setForm({ name:"",email:"",phone:"",service:"",query:"" }); }}
                  style={{
                    background: "linear-gradient(135deg,#1E3A8A,#3B82F6)", color: "#fff",
                    border: "none", padding: "13px 28px", borderRadius: 10,
                    fontWeight: 700, fontSize: 14, cursor: "pointer", fontFamily: "'Sora',sans-serif",
                  }}>Send Another Message</button>
              </div>
            ) : (
              <>
                <h3 style={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, fontSize: 22, color: "#0F172A", marginBottom: 6 }}>
                  Send Us a Message
                </h3>
                <p style={{ color: "#9CA3AF", fontSize: 13.5, marginBottom: 32 }}>Fill out the form and we'll get back to you shortly.</p>

                <form onSubmit={handleSubmit}>
                  {/* Name + Email row */}
                  <div className="form-row" style={{ marginBottom: 16 }}>
                    <div>
                      <label style={{ display: "block", fontSize: 12.5, fontWeight: 700, color: "#374151", marginBottom: 7, textTransform: "uppercase", letterSpacing: ".05em" }}>
                        Full Name <span style={{ color: "#EF4444" }}>*</span>
                      </label>
                      <div style={{ position: "relative" }}>
                        <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 16, pointerEvents: "none" }}>👤</span>
                        <input
                          name="name" value={form.name} onChange={handleChange}
                          onFocus={() => setFocused("name")} onBlur={() => setFocused(null)}
                          placeholder="Enter Your Name"
                          required
                          style={{ ...inputStyle("name"), paddingLeft: 42 }}
                        />
                      </div>
                    </div>
                    <div>
                      <label style={{ display: "block", fontSize: 12.5, fontWeight: 700, color: "#374151", marginBottom: 7, textTransform: "uppercase", letterSpacing: ".05em" }}>
                        Email Address <span style={{ color: "#EF4444" }}>*</span>
                      </label>
                      <div style={{ position: "relative" }}>
                        <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 16, pointerEvents: "none" }}>✉️</span>
                        <input
                          type="email" name="email" value={form.email} onChange={handleChange}
                          onFocus={() => setFocused("email")} onBlur={() => setFocused(null)}
                          placeholder="name@company.com"
                          required
                          style={{ ...inputStyle("email"), paddingLeft: 42 }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Phone + Service row */}
                  <div className="form-row" style={{ marginBottom: 16 }}>
                    <div>
                      <label style={{ display: "block", fontSize: 12.5, fontWeight: 700, color: "#374151", marginBottom: 7, textTransform: "uppercase", letterSpacing: ".05em" }}>
                        Contact Number <span style={{ color: "#EF4444" }}>*</span>
                      </label>
                      <div style={{ position: "relative" }}>
                        <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 16, pointerEvents: "none" }}>📞</span>
                        <input
                          type="tel" name="phone" value={form.phone} onChange={handleChange}
                          onFocus={() => setFocused("phone")} onBlur={() => setFocused(null)}
                          placeholder="Enter Your Contact"
                          required
                          style={{ ...inputStyle("phone"), paddingLeft: 42 }}
                        />
                      </div>
                    </div>
                    <div>
                      <label style={{ display: "block", fontSize: 12.5, fontWeight: 700, color: "#374151", marginBottom: 7, textTransform: "uppercase", letterSpacing: ".05em" }}>
                        Service Needed
                      </label>
                      <div style={{ position: "relative" }}>
                        <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 16, pointerEvents: "none" }}>🛠️</span>
                        <select
                          name="service" value={form.service} onChange={handleChange}
                          onFocus={() => setFocused("service")} onBlur={() => setFocused(null)}
                          style={{ ...inputStyle("service"), paddingLeft: 42, appearance: "none", cursor: "pointer" }}
                        >
                          <option value="">Select a service…</option>
                          {services.map(s => <option key={s} value={s}>{s}</option>)}
                        </select>
                        <span style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", fontSize: 12, color: "#9CA3AF", pointerEvents: "none" }}>▾</span>
                      </div>
                    </div>
                  </div>

                  {/* Query textarea */}
                  <div style={{ marginBottom: 28 }}>
                    <label style={{ display: "block", fontSize: 12.5, fontWeight: 700, color: "#374151", marginBottom: 7, textTransform: "uppercase", letterSpacing: ".05em" }}>
                      Your Query / Project Details <span style={{ color: "#EF4444" }}>*</span>
                    </label>
                    <div style={{ position: "relative" }}>
                      <span style={{ position: "absolute", left: 14, top: 15, fontSize: 16, pointerEvents: "none" }}>💬</span>
                      <textarea
                        name="query" value={form.query} onChange={handleChange}
                        onFocus={() => setFocused("query")} onBlur={() => setFocused(null)}
                        placeholder="Tell us about your project — what you want to build, your timeline, budget, and any specific requirements…"
                        rows={5} required
                        style={{ ...inputStyle("query"), paddingLeft: 42, resize: "vertical", minHeight: 130, lineHeight: 1.7 }}
                      />
                    </div>
                    <div style={{ textAlign: "right", fontSize: 11, color: "#9CA3AF", marginTop: 4 }}>{form.query.length} / 1000</div>
                  </div>

                  {/* Privacy note */}
                  <p style={{ fontSize: 12, color: "#9CA3AF", marginBottom: 20, lineHeight: 1.6 }}>
                    🔒 Your information is 100% secure and will never be shared with third parties. By submitting, you agree to our Privacy Policy.
                  </p>

                  {/* Submit button */}
                  <button type="submit" disabled={loading}
                    style={{
                      width: "100%", padding: "15px", borderRadius: 12,
                      background: loading ? "#93C5FD" : "linear-gradient(135deg,#1E3A8A,#3B82F6)",
                      color: "#fff", border: "none", cursor: loading ? "not-allowed" : "pointer",
                      fontWeight: 800, fontSize: 16, fontFamily: "'Sora',sans-serif",
                      boxShadow: loading ? "none" : "0 8px 24px rgba(59,130,246,.4)",
                      transition: "all .25s", display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
                    }}
                    onMouseEnter={e => { if (!loading) { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 12px 32px rgba(59,130,246,.5)"; }}}
                    onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 8px 24px rgba(59,130,246,.4)"; }}
                  >
                    {loading ? (
                      <>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ animation: "spin 1s linear infinite" }}>
                          <circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,.3)" strokeWidth="3"/>
                          <path d="M12 2 A10 10 0 0 1 22 12" stroke="white" strokeWidth="3" strokeLinecap="round"/>
                        </svg>
                        Sending your message…
                      </>
                    ) : (
                      <>🚀 Send Message — It's Free</>
                    )}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

// ── CTA Section ───────────────────────────────────────────────────────────────



// ── Footer ────────────────────────────────────────────────────────────────────

function Footer() {
  const cols = [
    { title: "Services", links: ["Web Development", "Mobile Apps", "AI & ML", "Cloud & DevOps", "UI/UX Design", "E-Commerce"] },
    { title: "Company", links: ["About Us", "Portfolio", "Blog", "Careers", "Contact", "Privacy Policy"] },
    { title: "Technologies", links: ["React & Next.js", "Flutter & RN", "Node.js & Laravel", "AWS & GCP", "Docker & K8s", "Python & AI"] },
  ];
  return (
    <footer style={{ background: "#0F172A", color: "#fff", padding: "72px 40px 32px" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <div className="footer-grid" style={{ marginBottom: 56 }}>
          <div>
            <div style={{ marginBottom: 16 }}>
              <img src={LOGO_SRC} alt="Techvanto — Inspiring generations"
                style={{ height: 140, width: "auto", objectFit: "contain", filter: "brightness(0) invert(1)", display: "block" }} />
            </div>
            <p style={{ color: "#94A3B8", lineHeight: 1.75, fontSize: 14, maxWidth: 300, marginBottom: 24 }}>
              Building world-class digital products for businesses across 20+ countries. Innovation. Scale. Excellence.
            </p>
            <div style={{ display: "flex", gap: 12 }}>
              {["𝕏", "in", "𝔾", "▶"].map((icon, i) => (
                <a key={i} href="#" style={{
                  width: 38, height: 38, borderRadius: 10, background: "rgba(255,255,255,.08)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: "#94A3B8", textDecoration: "none", fontSize: 14, fontWeight: 700,
                  transition: "all .2s",
                }}
                  onMouseEnter={e => { e.currentTarget.style.background = "#3B82F6"; e.currentTarget.style.color = "#fff"; }}
                  onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,.08)"; e.currentTarget.style.color = "#94A3B8"; }}
                >{icon}</a>
              ))}
            </div>
          </div>
          {cols.map(col => (
            <div key={col.title}>
              <h4 style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: 14, color: "#fff", marginBottom: 20, letterSpacing: ".04em" }}>{col.title}</h4>
              {col.links.map(l => (
                <a key={l} href="#" style={{ display: "block", color: "#64748B", fontSize: 13.5, textDecoration: "none", marginBottom: 10, transition: "color .15s" }}
                  onMouseEnter={e => e.target.style.color = "#93C5FD"}
                  onMouseLeave={e => e.target.style.color = "#64748B"}
                >{l}</a>
              ))}
            </div>
          ))}
        </div>
        <div className="footer-bottom" style={{ borderTop: "1px solid #1E293B", paddingTop: 28, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
          <p style={{ color: "#475569", fontSize: 13 }}>© 2025 Techvanto Private Limited. All rights reserved.</p>
          <p style={{ color: "#475569", fontSize: 13 }}>Made with ❤️ in India 🇮🇳</p>
        </div>
      </div>
    </footer>
  );
}

// ── Root Portfolio Page ───────────────────────────────────────────────────────

export default function Portfolio() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700;800;900&display=swap');

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        html { scroll-behavior: smooth; }
        body { font-family: 'Sora', -apple-system, sans-serif; background: #fff; color: #0F172A; overflow-x: hidden; }

        @keyframes fadeIn  { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:none; } }
        @keyframes pulse   { 0%,100% { opacity:1; } 50% { opacity:.4; } }
        @keyframes spin    { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }

        .nav-links       { display:flex; align-items:center; gap:4px; }
        .nav-cta         { display:flex !important; }
        .mob-menu-btn    { display:none; }
        .footer-grid     { display:grid; grid-template-columns:2fr 1fr 1fr 1fr; gap:48px; }
        .stats-grid      { display:grid; grid-template-columns:repeat(4,1fr); gap:40px; }
        .process-grid    { display:grid; grid-template-columns:repeat(5,1fr); gap:0; position:relative; }
        .featured-project-grid { display:grid; grid-template-columns:1fr 1fr; gap:56px; align-items:center; }
        
        /* ── Unified Contact Layout Styles ── */
        .contact-grid {
          display: grid;
          grid-template-columns: 1fr 1.35fr;
          align-items: stretch;
          background: #fff;
          border-radius: 24px;
          box-shadow: 0 16px 48px rgba(0,0,0,.06);
          border: 1px solid #E5E7EB;
          overflow: hidden;
        }
        .info-panel { padding: 48px 44px; }
        .form-panel { padding: 48px 52px; }
        .form-row   { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }

        @media (max-width:1100px) {
          .footer-grid   { grid-template-columns:1fr 1fr; gap:32px; }
          .stats-grid    { grid-template-columns:repeat(2,1fr); }
          .process-grid  { grid-template-columns:repeat(3,1fr); gap:24px; }
        }
        @media (max-width:900px) {
          .featured-project-grid { grid-template-columns:1fr !important; gap:36px !important; direction:ltr !important; }
          .footer-grid   { grid-template-columns:1fr 1fr; gap:32px; }
          .contact-grid  { grid-template-columns:1fr; }
          .form-row      { grid-template-columns:1fr; }
          .form-panel    { padding: 40px 32px; }
          .nav-links     { display:none !important; }
          .nav-cta       { display:none !important; }
          .mob-menu-btn  { display:flex !important; }
          .section-pad   { padding-left:20px !important; padding-right:20px !important; }
          .cta-section   { margin:0 16px 48px !important; padding:48px 24px !important; }
          .process-line  { display:none !important; }
        }
        @media (max-width:640px) {
          .footer-grid   { grid-template-columns:1fr; }
          .stats-grid    { grid-template-columns:repeat(2,1fr); gap:24px; }
          .process-grid  { grid-template-columns:1fr 1fr; gap:20px; }
          .section-pad   { padding-left:16px !important; padding-right:16px !important; padding-top:64px !important; padding-bottom:64px !important; }
          .cta-section   { margin:0 12px 40px !important; padding:40px 20px !important; }
          .info-panel    { padding: 36px 24px; }
          .form-panel    { padding: 36px 24px; }
        }
        @media (max-width:500px) {
          .topbar-right  { display:none !important; }
          .footer-bottom { flex-direction:column !important; text-align:center; gap:6px; }
        }
        @media (max-width:400px) {
          .form-row      { grid-template-columns:1fr; }
        }
      `}</style>

      <PortfolioHero />
      <StatsBar />
      <FeaturedProjects />
      <ProjectsGrid />
      <Industries />
      <Approach />
      
    </>
  );
}